export const MAX_NOTIFICATIONS = 500;

const notificationsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'NOTIFICATIONS_CONNECTING':
            return Object.assign({}, state, {
                listIsLoading: true
            });
        case 'NOTIFICATIONS_CONNECTED':
            return Object.assign({}, state, {
                listIsLoading: false
            });
        case 'SET_NOTIFICATIONS': {
            const newData = action.data;
            if (newData.notifications.list.length > MAX_NOTIFICATIONS) {
                newData.notifications.list = newData.notifications.list.slice(-MAX_NOTIFICATIONS);
                newData.notifications.count = newData.notifications.list.length;
            }
            return Object.assign({}, state, {
                data: newData,
                listIsLoading: false,
                isLoadingMore: false
            });
        }
        case 'ADD_NOTIFICATION': {
            const newData = action.data;
            if (newData.notifications.list.length > MAX_NOTIFICATIONS) {
                newData.notifications.list = newData.notifications.list.slice(-MAX_NOTIFICATIONS);
            }
            // notificationMiddleware.jsx only ever sends the fields it actually knows
            // about (unreadCount, totalCount, notifications) - a plain replace here
            // silently dropped everything else already in state.data (nextCursor,
            // most notably, breaking "load more" the moment a live push arrived).
            // Spread instead, same as every other partial-update case below.
            return Object.assign({}, state, {
                data: {...state.data, ...newData},
                listIsLoading: false
            });
        }
        case 'FETCH_MORE_NOTIFICATIONS':
            return Object.assign({}, state, {
                isLoadingMore: true
            });
        case 'APPEND_OLDER_NOTIFICATIONS': {
            const existingList = state.data?.notifications?.list ?? [];
            let mergedList = [...action.data.list, ...existingList];
            if (mergedList.length > MAX_NOTIFICATIONS) {
                mergedList = mergedList.slice(-MAX_NOTIFICATIONS);
            }
            return Object.assign({}, state, {
                isLoadingMore: false,
                data: {
                    ...state.data,
                    nextCursor: action.data.nextCursor,
                    notifications: {...state.data?.notifications, list: mergedList, count: mergedList.length}
                }
            });
        }
        case 'NOTIFICATIONS_LOAD_MORE_FAILED':
            return Object.assign({}, state, {
                isLoadingMore: false
            });
        case 'MARK_NOTIFICATION_READ': {
            const list = state.data?.notifications?.list ?? [];
            const wasUnread = list.some((it) => it.ID === action.id && !it.IsRead);
            const updatedList = list.map((it) => it.ID === action.id ? {...it, IsRead: true} : it);

            return Object.assign({}, state, {
                data: {
                    ...state.data,
                    unreadCount: Math.max(0, (state.data?.unreadCount ?? 0) - (wasUnread ? 1 : 0)),
                    notifications: {...state.data?.notifications, list: updatedList}
                }
            });
        }
        case 'CLEAR_NOTIFICATION': {
            const list = state.data?.notifications?.list ?? [];
            const removed = list.find((it) => it.ID === action.id);
            const updatedList = list.filter((it) => it.ID !== action.id);

            return Object.assign({}, state, {
                data: {
                    ...state.data,
                    unreadCount: Math.max(0, (state.data?.unreadCount ?? 0) - (removed && !removed.IsRead ? 1 : 0)),
                    totalCount: Math.max(0, (state.data?.totalCount ?? 0) - (removed ? 1 : 0)),
                    notifications: {...state.data?.notifications, list: updatedList, count: updatedList.length}
                }
            });
        }
        case 'CLEAR_ALL_NOTIFICATIONS':
            return Object.assign({}, state, {
                data: {
                    ...state.data,
                    unreadCount: 0,
                    totalCount: 0,
                    nextCursor: null,
                    notifications: {...state.data?.notifications, list: [], count: 0}
                }
            });
        case 'MARK_ALL_NOTIFICATIONS_READ': {
            const list = state.data?.notifications?.list ?? [];
            const updatedList = list.map((it) => ({...it, IsRead: true}));

            return Object.assign({}, state, {
                data: {
                    ...state.data,
                    unreadCount: 0,
                    notifications: {...state.data?.notifications, list: updatedList}
                }
            });
        }
        case 'GET_NOTIFICATION_LIST':
            return Object.assign({}, state, {
                listIsLoading: true,
                unreadCount: 0
            });

        case 'DONE_GET_NOTIFICATION_LIST':
            return Object.assign({}, state, {
                listIsLoading: false,
                list: action.data
            });
        case 'ERROR_GET_NOTIFICATION_LIST':
            return Object.assign({}, state, {
                listIsLoading: false,
                errorNotificationList: true
            });
        default:
            return state;
    }
};

export default notificationsReducer;
